import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import PropTypes from 'prop-types'
import React from 'react'
import ReactDOM from 'react-dom'

import courierIcon from '../CartRussiaRedesign/assets/how-it-works/courier.svg'
import closeIcon from '../CartRussiaRedesign/assets/how-it-works/close.svg'
import stepOneIllustration from '../CartRussiaRedesign/assets/how-it-works/step1-group.png'
import stepTwoIllustration from '../CartRussiaRedesign/assets/how-it-works/step2-hands.png'
import stepThreeLaptop from '../CartRussiaRedesign/assets/how-it-works/step3-laptop.png'
import stepThreeScreen from '../CartRussiaRedesign/assets/how-it-works/step3-screen.png'

import {
  CloseButton,
  CloseIcon,
  DesktopOnlyBreak,
  MobileOnlyBreak,
  ModalCard,
  ModalOverlay,
  ModalRoot,
  ModalScroller,
  ModalTitle,
  ModalTitleBreak,
  StepBadge,
  StepLink,
  StepNoteIcon,
  StepNoteRow,
  StepThreeHint,
  StepThreeIllustration,
  StepThreeLaptop,
  StepThreeScreen,
  StepThreeText,
  Steps,
  StepText,
  StepOneIllustrationFrame,
  StepOneIllustration,
  StepTwoIllustration,
  StepTwoIllustrationFrame,
  StepTwoIllustrationImage,
  StepTwoNoteText,
  StepTwoText,
  StepCard,
  StepThreeScreenFrame,
} from './styles'

const CartHowItWorksModal = ({ isOpen, onClose }) => {
  const scrollerRef = React.useRef(null)
  const [portalNode, setPortalNode] = React.useState(null)

  React.useEffect(() => {
    setPortalNode(document.body)
  }, [])

  React.useEffect(() => {
    if (!isOpen || !scrollerRef.current) return undefined

    const reactRoot = document.getElementById('__next')
    const hiddenWidgets = Array.from(document.querySelectorAll('pf-widget')).map(
      node => ({
        node,
        pointerEvents: node.style.pointerEvents,
        visibility: node.style.visibility,
      }),
    )
    const handleKeyDown = event => {
      if (event.keyCode === 27) {
        onClose()
      }
    }

    disableBodyScroll(scrollerRef.current)
    window.addEventListener('keydown', handleKeyDown)

    if (reactRoot) {
      reactRoot.style.overflow = 'hidden'
    }

    hiddenWidgets.forEach(({ node }) => {
      node.style.pointerEvents = 'none'
      node.style.visibility = 'hidden'
    })

    return () => {
      clearAllBodyScrollLocks()
      window.removeEventListener('keydown', handleKeyDown)

      if (reactRoot) {
        reactRoot.removeAttribute('style')
      }

      hiddenWidgets.forEach(({ node, pointerEvents, visibility }) => {
        node.style.pointerEvents = pointerEvents
        node.style.visibility = visibility
      })
    }
  }, [isOpen, onClose])

  if (!isOpen || !portalNode) {
    return null
  }

  return ReactDOM.createPortal(
    <ModalRoot aria-modal="true" role="dialog">
      <ModalOverlay aria-label="Закрыть модальное окно" onClick={onClose} />
      <ModalScroller onClick={onClose} ref={scrollerRef}>
        <ModalCard onClick={event => event.stopPropagation()}>
          <CloseButton aria-label="Закрыть" onClick={onClose}>
            <CloseIcon alt="" aria-hidden="true" src={closeIcon} />
          </CloseButton>

          <ModalTitle>
            Как это <ModalTitleBreak>работает?</ModalTitleBreak>
          </ModalTitle>

          <Steps>
            <StepCard>
              <StepBadge>1</StepBadge>
              <StepText>
                Соберите биоматериал
                <DesktopOnlyBreak />
                <MobileOnlyBreak />
                по инструкции в наборе
              </StepText>
              <StepOneIllustrationFrame aria-hidden="true">
                <StepOneIllustration alt="" src={stepOneIllustration} />
              </StepOneIllustrationFrame>
            </StepCard>

            <StepCard>
              <StepBadge>2</StepBadge>
              <StepTwoText>
                Вызовите нашего курьера через
                <DesktopOnlyBreak />
                {' '}личный кабинет{' '}
                <MobileOnlyBreak />
                или по телефону
              </StepTwoText>
              <StepNoteRow>
                <StepNoteIcon alt="" src={courierIcon} />
                <StepTwoNoteText>
                  Курьер приедет{' '}
                  <MobileOnlyBreak />
                  бесплатно
                </StepTwoNoteText>
              </StepNoteRow>
              <StepTwoIllustration aria-hidden="true">
                <StepTwoIllustrationFrame>
                  <StepTwoIllustrationImage alt="" src={stepTwoIllustration} />
                </StepTwoIllustrationFrame>
              </StepTwoIllustration>
            </StepCard>

            <StepCard>
              <StepBadge>3</StepBadge>
              <StepThreeText>
                Дождитесь результатов теста
                <DesktopOnlyBreak />
                {' '}в онлайн-кабинете
                <MobileOnlyBreak />
                {' '}на{' '}
                <StepLink>atlas.ru</StepLink>
              </StepThreeText>
              <StepThreeHint>~ 8 недель</StepThreeHint>
              <StepThreeIllustration aria-hidden="true">
                <StepThreeLaptop alt="" src={stepThreeLaptop} />
                <StepThreeScreenFrame>
                  <StepThreeScreen alt="" src={stepThreeScreen} />
                </StepThreeScreenFrame>
              </StepThreeIllustration>
            </StepCard>
          </Steps>
        </ModalCard>
      </ModalScroller>
    </ModalRoot>,
    portalNode,
  )
}

CartHowItWorksModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default CartHowItWorksModal
